import React from "react";
import { motion } from "framer-motion";
import "../components/LatestCollection.css";
import img1 from "../assets/f1.jpg";
// import img2 from "../assets/t2.jpg";
// import img3 from "../assets/shirt1.jpg";
import img4 from "../assets/woman-sportsshoe.webp";
// import img5 from "../assets/lower2.jpg";
// import img6 from "../assets/jeans.jpg";

const collections = [
  {
    id: 1,
    title: "Women Slippers & Sandals",
    image:img1,
  },
  {
    id: 2,
    title: "Women Sports Shoes",
    image: img4,
  },
//   {
//     id: 3,
//     title: "Mens T-Shirts",
//     image: img2,
//   },
//   {
//     id: 4,
//     title: "Mens Shirts",
//     image: img3,
//   },
//   {
//     id: 5,
//     title: "Mens Shorts & Lower",
//     image:img5,
//   },
//   {
//     id: 6,
//     title: "Mens Jeans & Pant",
//     image:img6,
//   },
];

export default function WomenFootWearCollection() {
  return (
    <section className="latest-collection">
      <div className="collection-header">
        <h2>Women FootWear Product Showcase</h2>
      </div>

      <div className="collection-grid two-center">
        {collections.map((item, index) => (
          <motion.div
            key={item.id}
            className="collection-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.2, duration: 0.6 }}
            whileHover={{ scale: 1.05 }}
          >
            <img src={item.image} alt={item.title} />
            <h4>{item.title}</h4>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
